import React, {useState} from 'react';

import MainModal from 'shared/ui/Modal/MainModal';
import {ITariff} from 'entities/tariff';

import {t} from '@lingui/core/macro';

import TariffForm from './TariffForm/TariffForm';
import LegalSuccessModal from './LegalSuccessModal/LegalSuccessModal';

interface ITariffModalProps {
    open: boolean;
    handleClose: () => void;
    item: ITariff & {
        period: number;
        price: number;
    };
    userCurrentTariff?: {
        id: number;
        name: string;
        is_archive?: boolean;
        price?: number;
    };
}

const TariffModal: React.FC<ITariffModalProps> = ({open, item, handleClose, userCurrentTariff}) => {
    const [showLegalSuccess, setShowLegalSuccess] = useState(false);

    const handleLegalSuccess = () => {
        handleClose();
        setShowLegalSuccess(true);
    };

    const handleLegalSuccessClose = () => {
        setShowLegalSuccess(false);
    };

    return (
        <>
            <MainModal
                header={t`Оплата тарифа`}
                open={open}
                handleClose={handleClose}
                size="sm"
            >
                <TariffForm
                    onSuccess={handleClose}
                    onLegalSuccess={handleLegalSuccess}
                    item={item}
                    userCurrentTariff={userCurrentTariff}
                />
            </MainModal>


            <LegalSuccessModal
                item={item}
                open={showLegalSuccess}
                onClose={handleLegalSuccessClose}
            />
        </>
    );
};

export default TariffModal;